'use client'

import { useState, useEffect, useCallback } from 'react';
import { Modal } from './Modal';
import { CardPaymentFlow } from './CardPaymentFlow';
// We might need useAccount if we need to check connection status, but CardPaymentFlow seems to handle its own auth/user details.
// import { useAccount } from 'wagmi';

interface CardPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectUsdtWalletAddress?: string;
  isMounted: boolean;
  onGetSignatureForMoonPay: (urlToSign: string) => Promise<string>;
  onMoonPayTransactionCompleted: (event: any) => Promise<void>;
  onMoonPayLogin: (props: any) => Promise<void>;
  onBackToPaymentSelection?: () => void;
  // Add onBackToPaymentSelection if this modal is part of a larger flow where users can go back.
  // For now, assuming it's a standalone modal for card payments triggered elsewhere.
}

export const CardPaymentModal = ({ 
  isOpen, 
  onClose,
  projectUsdtWalletAddress,
  isMounted,
  onGetSignatureForMoonPay,
  onMoonPayTransactionCompleted,
  onMoonPayLogin,
  onBackToPaymentSelection,
}: CardPaymentModalProps) => {
  // CardPaymentFlow manages its own internal steps.
  // We don't need currentStep and totalSteps in the Modal for CardPaymentFlow as it doesn't expose them directly.
  // If step indication in the modal title is desired, CardPaymentFlow would need to be modified
  // to report its current step and total steps, similar to PurchaseFlow.

  // For now, the Modal will just have a static title.
  
  useEffect(() => {
    // Reset internal states of CardPaymentFlow when modal is closed or opened
    // CardPaymentFlow itself has an effect for when isOpen becomes false.
    // We might not need additional reset logic here unless CardPaymentFlow's internal reset is insufficient.
    if (!isOpen) {
        // console.log("CardPaymentModal closed, CardPaymentFlow should reset itself.");
    }
  }, [isOpen]);

  if (!isMounted) {
    return null; // Or a loading spinner, consistent with CardPaymentFlow
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="Pay with Card" // Static title for now
      // currentStep and totalSteps are not used here as CardPaymentFlow does not expose this
    >
      <CardPaymentFlow 
        isOpen={isOpen} // Pass isOpen to CardPaymentFlow for its internal logic
        onClose={onClose} 
        onBackToPaymentSelection={onBackToPaymentSelection}
        projectUsdtWalletAddress={projectUsdtWalletAddress}
        isMounted={isMounted}
        onGetSignatureForMoonPay={onGetSignatureForMoonPay}
        onMoonPayTransactionCompleted={onMoonPayTransactionCompleted}
        onMoonPayLogin={onMoonPayLogin}
      />
    </Modal>
  );
}; 